import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'react-admin';
import { closeDoc, openDoc, updateDoc } from 'store/actions/lightboxActions';
import useCustomNotify from 'hooks/useCustomNotify';

const useGroupPackingSlips = (
  type: string,
  id: string | null,
  ids: string[] | null,
  isGroup: boolean,
  trackingNumbers: string[] = []
) => {
  const [openingDocument, setOpeningDocument] = useState(false);
  const dataProvider = useDataProvider();
  const notify = useCustomNotify();
  const dispatch = useDispatch();

  const openDocument = async () => {
    if (openingDocument) {
      return;
    }

    setOpeningDocument(true);

    const loadingDocument = openDoc({
      name: 'Packing Slip',
      documentType: 'packingSlip',
      labelMode: type === 'shipments' ? 'groupedShipments' : 'multi',
      trackingNumbers,
      loading: true,
    });

    dispatch(loadingDocument);

    try {
      const {
        data: { url },
      } = await (isGroup
        ? dataProvider.getNest('groupPackingSlips', { type, id })
        : dataProvider.create('multiplePackingSlips', { type, data: ids }));

      dispatch(
        updateDoc(loadingDocument.payload.id, {
          url,
          loading: false,
        })
      );
    } catch (error) {
      dispatch(closeDoc(loadingDocument.payload.id));
      const errorMessage =
        error instanceof Error ? error.message : 'An error occurred while opening packing slip';
      notify(errorMessage, 'error');
    } finally {
      setOpeningDocument(false);
    }
  };

  return { openingDocument, openDocument };
};

export default useGroupPackingSlips;
